export enum MedRecordType {
  /** Тип мед записи*/
  Inspection = 0,
  ClinicDentict = 2,
  Diagnose = 3,
  Appointments = 4,
  ResultsOfDiagnosticStudies = 5,
  SignalInformation = 7,
  Epicrisis = 8,
  MedDocumentPrintForms = 9,
  /**Печатная форма для клиники */
  MedDocumentPrintForm12 = 100,
  MedDocumentPrintForm003 = 101,
  MedDocumentPrintForm0031 = 102,
  MedDocumentPrintForm096 = 103,
  MedDocumentPrintForm097 = 104,
  PrescriptionBlank = 105,
  Contract = 106,
  Form024_1 = 107,
  Form027 = 108,
  Form066 = 109,
  Form110 = 110,
  Form111,
  Form112,
  Form113,
  Form114,
  Form115,
  Form116,
  Form117,
  Form118,
  Form119,
  Form120,
  Form121,
  Form122,
  Form123,
  Form124,
  Form125,
  Form126,
  Form127,
  Form128,
  Form129,
  Form130,
  Form131,
  Form132,
  Form133,
  Form134,
  Form135,
  Form136,
  Form137,
  Form138,
  Form139,
  Form140,
  Form141,
  Form142,
  Form143,
  Form144,
  Form145,
  Form146,
  Form147,
  Form148,
  Form149,
  Form150,
  Form151,
  Form152,
  Form153,
  Form154,
  Form155,
  Form156,
  Form157,
  Form158,
  Form159,
  Form160,
  Form161
}
